// extracted by mini-css-extract-plugin
module.exports = {"modal-title":"_2b7N46sJjMZ3gBbW0joBO4","modal-body":"_3K4AZaMB2NyAXriH0EDsV7","old-reason-field":"_1t3qLmuPno6m_hq3rRVXrv"};